import { render, staticRenderFns } from "./ListResellerProductPage.vue?vue&type=template&id=0138a920&"
import script from "./ListResellerProductPage.vue?vue&type=script&lang=js&"
export * from "./ListResellerProductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports